module.exports = __webpack_public_path__ + "static/img/appointment.b1537d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appointment.jpg
// module id = 7Fnz
// module chunks = 0